import React from "react";
import type { Severity, IncidentStatus, SiteHealth } from "../types/dashboard.js";

const SEVERITY_LABEL: Record<Severity, string> = {
  info: "Info",
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
};

const SEVERITY_CLASS: Record<Severity, string> = {
  info: "badge-default",
  low: "badge-default",
  medium: "badge-warning",
  high: "badge-danger",
  critical: "badge-danger",
};

export function SeverityBadge({ severity }: { severity: Severity }): React.ReactElement {
  return <span className={SEVERITY_CLASS[severity]}>{SEVERITY_LABEL[severity]}</span>;
}

const STATUS_LABEL: Record<IncidentStatus, string> = {
  open: "Open",
  ack: "已確認",
  resolved: "已處理",
};
const STATUS_CLASS: Record<IncidentStatus, string> = {
  open: "badge-danger",
  ack: "badge-warning",
  resolved: "badge-success",
};

export function StatusBadge({ status }: { status: IncidentStatus }): React.ReactElement {
  return <span className={STATUS_CLASS[status]}>{STATUS_LABEL[status]}</span>;
}

const HEALTH_CLASS: Record<SiteHealth, string> = {
  healthy: "badge-success",
  warning: "badge-warning",
  critical: "badge-danger",
};
const HEALTH_LABEL: Record<SiteHealth, string> = {
  healthy: "正常",
  warning: "警示",
  critical: "緊急",
};

export function HealthBadge({ health }: { health: SiteHealth }): React.ReactElement {
  return <span className={HEALTH_CLASS[health]}>{HEALTH_LABEL[health]}</span>;
}
